<template>
  <div class="nsale_ myPage_ poster_">
    <div class="list_">
      <div class="poster_outer">
        <img
          style="height: 100%;width: 100%;"
          v-if="step == '2'"
          class="poster_img"
          :src="uploadImg"
          alt="posterImg"
        />
        <div v-if="step == '2'" class="saveTip">
          <span>长按可保存海报</span>
        </div>
      </div>

      <div class="item_" id="posterHtml" v-if="step == '1'">
        <div class="item_1">
          <img class="item_1img" :src="postInfo.img" alt="poster" />
        </div>
        <div class="item_2">
          <img class="item_2img" :src="postInfo.qrcode" alt="code" />
          <div>
            <p class="txt txt1">{{ postInfo.name }}</p>
            <!-- <p class="txt txt2">
              {{ postInfo.des }}
            </p> -->
            <p class="txt txt2">
              {{ postInfo.des1 }}
            </p>
            <p class="txt txt2">
              {{ postInfo.des2 }}
            </p>
          </div>
        </div>
      </div>

      <div class="item_" id="posterHtml" v-if="step == '3'">
        <div class="item_1">
          <img class="item_1img" :src="postInfo.img" alt="poster" />
          <!-- <img class="item_1img" src="../../../assets/image/nsale/post.jpg" alt="poster" />  -->
        </div>
        <div class="item_2">
          <img class="item_2img" :src="postInfo.qrcode" alt="code" />
          <div style="margin-left:10px;width: 215px;" v-if="showPoster">
            <cube-input
              class="inputStyle"
              v-model="form.name"
              placeholder="请输入您的姓名"
            ></cube-input>
            <!-- <cube-input
              class="inputStyle"
              v-model="form.des"
              placeholder="请输入您想说的话（30字以内）"
            ></cube-input> -->
            <cube-textarea
              :maxlength="30"
              :indicator="false"
              v-model="form.des"
              placeholder="请输入您想说的话（30字以内）"
            ></cube-textarea>
          </div>
          <div v-else>
            <p class="txt txt1">{{ form.name }}</p>
            <p class="txt txt2">
              {{ form.des }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- <cube-button class="btn_" @click="handle">完成</cube-button> -->
    <div v-if="step == '3'">
      <cube-button class="btn_" @click="handle">完成</cube-button>
    </div>
    <cube-button v-else class="btn_" @click="handleEdit">编辑海报</cube-button>

    <div class="mask" v-if="cannotInvited">
      <div class="tips">{{ cannotInvitedText }}</div>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import api from "@/utils/api";
import apiNsale from "@/utils/nsaleApi.js"
export default {
  data() {
    return {
      cannotInvited: false, // 代理人是否被风控禁止邀新
      cannotInvitedText: "暂时不能邀请哦", // 禁止信息
      inviteUrl: "",
      codeUrl: "",
      tempId: "",
      postInfo: {
        postImg: require("../../../assets/image/nsale/post.jpg"),
        name: "",
        des1: "",
        des2: "",
        img: ""
      },
      form: {
        name: "",
        des: ""
      },
      iosFirst: true,  //ios系统生成海报偏移问题：ios第一次生成
      uploadImg: "", //上传后的链接地址
      posterImg: "", // 最终生成的海报图片
      showPoster: true,
      preview: true,
      step: "1",
      edit: false
    };
  },
  mounted() {
    this.hideOptionMenu();
    this.tempId = this.$route.params.id;
    this.edit = this.$route.meta.edit;
    console.log(this.edit, "-------", this.$route.params, this.$route.query);
    this.postInfo = JSON.parse(localStorage.getItem("postInfo"));
    this.checkInvite();
    if (!this.edit && this.postInfo) {
      let st = setTimeout(() => {
        this.createPoster();
        clearTimeout(st);
      }, 100);
      console.log("postInfo =>", this.postInfo);
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log("beforeRouteEnter -->", to, from);
    next();
  },
  activated() {
    console.log("activated -> ", 1, this.$route);
  },
  methods: {
    hideOptionMenu() {
      try {
        WeixinJSBridge.call("hideOptionMenu");
      } catch (error) {}
    },
    handle() {
      this.iosFirst = false;
      this.showPoster = false;
      let st = setTimeout(() => {
        this.createPoster();
        clearTimeout(st);
      }, 500);
    },
    // 禁止投保规则调用
    checkInvite() {
      const ruleCode = "202205278,20220805348"; // 生产
      // const ruleCode = "20220519913,20220812919"; // 测试
      const params = {
        cuswebuserid: this.postInfo.userId,
        operate: "禁止-邀请下级",
        ruleCode,
      };
      apiNsale.verifyState(params).then((res) => {
        let { returnCode, data } = res.data;
        if (returnCode === "0000" && data == "1") {
          // 状态为1禁止邀新
          this.cannotInvited = true;
          this.cannotInvitedText = '账号异常，暂无操作权限';
        }
      });
    },
    getRegisterLink() {
      return api
        .getRegisterLink(this.tempId)
        .then(res => res.data)
        .then(data => {
          let { returnCode, returnMsg, content } = data;
          if (returnCode === "9999") {
            this.cannotInvited = true;
            this.cannotInvitedText = returnMsg;
            return false;
          }
          return content;
        })
        .then(url => {
          if (!url) {
            return;
          }
          this.inviteUrl = url;
          import("jr-qrcode").then(jrQrcode => {
            // 模块方法调用，传入字符串，获取 base64 编码的图片 URL
            var imgBase64 = jrQrcode.getQrBase64(url);
            this.codeUrl = imgBase64;
          });
        });
    },
    base64(data) {
      api.base64(data).then(res => {
        this.uploadImg = res.data.content;
        this.step = "2";
      });
    },
    AndroisIos() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return true;
      } else if (isIOS) {
        return false;
      }
    },
    createPoster() {
      // 生成海报
      let isAndroid = this.AndroisIos();
      let xNum = 0;
      if (isAndroid) {
        xNum = 15;
      } else if (this.iosFirst && !isAndroid) {
        xNum = 16;
      } else if (!this.iosFirst && !isAndroid) {
        xNum = 1;
      }
      // alert(isAndroid)
      console.log(isAndroid, window.scrollY);
      const vm = this;
      const domObj = document.getElementById("posterHtml");
      html2canvas(domObj, {
        useCORS: true,
        // timeout: 500, // 加载延时
        // backgroundColor: null,
        width: domObj.offsetWidth, // 下面解决当页面滚动之后生成图片出现白边问题
        height: domObj.offsetHeight,
        // windowWidth: document.body.scrollWidth,
        // windowHeight: document.body.scrollHeight,
        // scrollY: 0,
        // scrollX: 0,
        // x: xNum,
        // y: 10,
        dpi: window.devicePixelRatio * 2, // 解决图片不清晰问题
        scale: 2,
        logging: false,
        // letterRendering: true,
        onclone(doc) {
          let e = doc.querySelector("#posterHtml");
          e.style.display = "block";
        }
      }).then(function(canvas) {
        // 在微信里,可长按保存或转发
        vm.posterImg = canvas.toDataURL("image/png");
        // this.step = "2";
        let data = { base64Img: vm.posterImg };
        vm.base64(data);
      });
    },
    handleEdit() {
      this.step = "3";
      this.showPoster = true;
      // this.$router.push({ path: `/nsale/postEdit/${this.tempId}` });
    }
  }
};
</script>

<style scoped lang="scss">
.nsale_ {
  background: rgba(245, 245, 245, 1);
  min-height: 100vh;
  .btn_ {
    width: 305px;
    height: 50px;
    background: rgba(255, 74, 53, 1);
    border-radius: 5px;
    margin: 10px auto;
  }
  .list_ {
    margin: 0 auto 20px;
    height: 614px;
    width: 345px;
    padding-top: 10px;
    .item_ {
      // width: 345px;
      .item_1 {
        height: 500px;
        position: relative;
        .item_1img {
          width: 100%;
          height: 100%;
        }
      }
      .item_2 {
        background: url("../../../assets/image/BLogo.jpg") no-repeat;
        background-size: 100% 100%;
        height: 115px;
        display: flex;
        align-items: center;
        font-size: 12px;
        color: rgba(102, 102, 102, 1);
        padding: 10px;
        .item_2img {
          width: auto;
          height: 75px;
        }
        .txt {
          text-align: left;
          margin-left: 10px;
        }
        .txt1 {
          margin-bottom: 10px;
          font-weight: bold;
          font-size: 18px;
          color: #333333;
        }
        .txt2 {
          width: 193px;
          line-height: 20px;
          color: #666666;
        }
      }
    }
  }

  .poster_outer {
    position: relative;
    .saveTip {
      position: absolute;
      left: 0;
      bottom: 120px;
      width: 345px;
      font-size: 11px;
      height: 25px;
      line-height: 25px;
      background: rgba(0, 0, 0, 1);
      opacity: 0.4;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        color: rgba(255, 255, 255, 1);
        opacity: 0.5;
      }
    }
  }

  .saveTip {
    width: 345px;
    font-size: 11px;
    height: 25px;
    line-height: 25px;
    background: rgba(0, 0, 0, 1);
    opacity: 0.4;
    position: absolute;
    bottom: 140px;
    left: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      color: rgba(255, 255, 255, 1);
      opacity: 0.5;
    }
  }
}
.mask {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  .tips {
    height: 42px;
    padding: 0 25px;
    background: #373737;
    border-radius: 21px;
    line-height: 42px;
    text-align: center;
    font-size: 13px;
    color: #fff;
  }
}
</style>
